/**
 * Brand Play 2 module
 *
 * Last Edit:
 * 07.22.16 by MN and AP => Inegrate new video (MedscapeTV video player) with the
 * BP1 template and get rid of CorelibBP3/Grunt. Now this script is part of the bundle
 * 09.15.17 adding MobileMenu module ....
 */

define(['jquery', 'StandardModule', 'Util', 'Tracking', '../../modules/definitions/mobile_menu.js'], function($, parentModel, Util, tracking, MobileMenu) {
    function thisObject(o) {
        var defaults = {
            type : 'module',
            author : 'EB, MN and AP',
            trackingBp : '',
            ippResumeEnable : true,
            ippResumeShow: true,
            totalVids : bpInstance.videos.length,
            specificPercentArray : [25, 50, 75],
            percentAlreadyTracked : [],
            stayAliveSeconds : 15,
            bookmarkedVid : 0,
            roadblock : '',
            switchVidNum : 1,
            switchVidFlag : false,
            playPauseClickFlag : false,
            ieScrubFlag : false,
            ieScrubDebounce : '',
            chpClickFlag : 0,
            tempLockVidControls : false,
            enableHeartbeat: true,
            bookmarkVidLoadingImage: 'pi/features/brandplay/blackpixel.png',
            isi : {
                showOnload : false,
                container : 'isiContainer'
            }
        };

        defaults = $.extend(true, defaults, o);
        parentModel.call(this, defaults);
        return (this);
    }

    // Inherit parent methods/variables
    thisObject.prototype = Object.create(parentModel.prototype);
    // set status of isi
    thisObject.prototype.isiStatus = {
        isOpen: false,
        setup: false
    };

    // Listeners
    thisObject.prototype._startlisteners = function() {
        this.notify('Trace', '_startlisteners');
        var parent = this;
        var self = this;
        var myID = this._id();
        var hasStartedParticipation = false;
    };

	/* Initialize function */
    thisObject.prototype.init = function() {
        this.notify('Trace', 'init');
        this._startlisteners();
        var self = this;

        window.s_business_reference = 'video-brandplay';

        // Play & pause click flag
        $('.active-video, .vjs-big-play-button, .vjs-play-control, .vjs-tech, .replayVideoButton, .nextVideoButton, .chapter, .chapter_icon, .chapter_text').on('click', function() {
            self._var().playPauseClickFlag = true;
        });

        if('onhashchange' in window) { // Set flag on hashchange for Mobile App to match web tracking. When users clicks chapter, it should send a 'play' tracking call as opposed to an autoplay.
            $(window).on('hashchange', function() {
                self._var().playPauseClickFlag = true;
            });
        }

        self.notify('GetTotalVidsOnPage', self._var().totalVids);
        self.notify('GetPercentages', self._var().specificPercentArray.toString());
        self.notify('StayAliveSeconds', self._var().stayAliveSeconds);

        $(document).ready(function() {
            self.$brandPlay = $('#brandPlay');
            self.$menuDropDown = $('#menuDropdown');
            self.$chapterMenu = $('#chapter-menu');
            self.$overlayNew = $('.overlay-new');
            self.$menu = $('#menu');
            self.$overlayClose = $('.overlay-close');
            self.$bpContent = $('#bp_content');
            self.$pageWrapper = $('#pageWrapper');
            self.$notes = $('#notes');
            self.$solidOverlay = $('#solidOverlay');
            self.$menuArrow = $('.menuArrow');
            self.$isiContainer = $('#isiContainer');
            self.$menuBG = $('#menuBG');
            self.$visPlayControl = $('.vjs-play-control');
            self.$bpDisclaimer = $('.bp_disclaimer');
            self.$sponsorLine = $('#sponsorLine');

            const isApp = window.medscape.core.isApp;
            const menuOpenClsName = 'menu_open';

            // doesn't appear to be returning true for app
            if(isApp) {
                // self.$overlayClose.hide();
                self.isApp = true;
            }

            // Play & pause click flag
            $('.active-video, .vjs-big-play-button, .vjs-play-control, .vjs-tech, .replayVideoButton, .nextVideoButton, .chapter, .chapter_icon, .chapter_text').on('click', function() {
                self._var().playPauseClickFlag = true;
            });

            if (!self._var().ippResumeEnable) {
                $('#chapter-1').addClass('playing');
            }

            self.$menuDropDown.find('.firstLink').hover(
                () => {
                    self.$menuArrow.addClass('arrowHoverColor');
                }, () => {
                    self.$menuArrow.removeClass('arrowHoverColor');
                });

            $(window).on('video_player:rendered', () => {
                self.playerReady = true;
            });

            // check the video element exist before binding event handlers
            function checkVideoElement() {
                if($('video').length === 0) {
                    window.requestAnimationFrame(checkVideoElement);
                } else {
                    self.$video = $('video');
                    addEventBinding();
                }
            }
            window.requestAnimationFrame(checkVideoElement);

            function addEventBinding() {
                self.$chapterMenu.on('click', function() {
                    // if desktop
                    if(!Util.isMobile() && !Util.isIpad())  {
                        if (!$(this).hasClass(menuOpenClsName)) {
                            self.$menu.removeClass(menuOpenClsName);
                            $(this).addClass(menuOpenClsName);
                            self.$menuDropDown
                                .hide()
                                .removeClass('open');
                            return false;
                        } else {
                            self.$menu.removeClass(menuOpenClsName);
                        }
                    }
                });

                if (!Util.isMobile() && !Util.isIpad()) {
                    self.$menu.on('click', function() {
                        if (!self.$menu.hasClass(menuOpenClsName)) {
                            self.$menu.removeClass(menuOpenClsName);
                            self.$menu.addClass(menuOpenClsName);
                            self.$menuDropDown
                                .show()
                                .addClass('open');
                            self.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_OPEN', 'vidvbp-action_sheet_open', this]);
                            return false;
                        } else {
                            self.$menu.removeClass(menuOpenClsName);
                            self.$menuDropDown
                                .hide()
                                .removeClass('open');
                            self.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_CLOSE', 'vidvbp-action_sheet_close', this]);
                        }
                    });
                }

                // The below code dismisses all modal layers when the user clicks outside of a modal layer
                self.$pageWrapper.on('click', function() {
                    if (self.$menu.hasClass(menuOpenClsName) || self.$chapterMenu.hasClass(menuOpenClsName)) {
                        self.$menu.removeClass(menuOpenClsName);
                        self.$menuDropDown
                            .hide()
                            .removeClass('open');
                        self.$brandPlay.removeClass('lock-isi');
                        self.$isiContainer.removeClass('lock-isi');
                        self.$video.removeClass('tempHideVideo');
                        self.notify('TrackBind', ['pamTrack', 'ACTIONSHEET_CLOSE', 'vidvbp-action_sheet_close', this]);
                    }
                });

                // Notes layer link bind
                self.$notes.on('click', function() {
                    self.$brandPlay.removeClass('lock-isi');
                    self.$isiContainer.removeClass('lock-isi');
                    self.$menuDropDown
                        .removeClass('open')
                        .hide();
                    if(self.$menu.hasClass(menuOpenClsName)) self.$menu.removeClass(menuOpenClsName);

                    self.$overlayNew.toggleClass('open');
                    if(self.$visPlayControl.length > 0) {
                        self.$visPlayControl
                            .removeClass('vjs-playing')
                            .addClass('vjs-paused');
                    }
                    $('body').addClass('notes-open');
                    self.notify('TrackBind', ['pamTrack', 'INFO', 'vidvbp-action-info_open', this]);
                    //keep this at the bottom of the click function.
                    _notify.broadcast('PauseAllVideoJSVids');
                    return false;
                });
                // X button on notes overlay layer
                self.$overlayClose.on('click', function() {
                    self.$overlayNew.removeClass('open');
                    $('body').removeClass('notes-open');
                    self.notify('TrackBind', ['pamTrack', 'INFO', 'vidvbp-action-info_close', this]);
                    return false;
                });

                // Clicking anywhere other than the notes layer dismisses the notes layer
                self.$overlayNew.on('click', function(e) {
                    if (e.target !== this)
                        return;
                    self.$overlayNew.removeClass('open');
                });

                // escape key exits the notes layer
                $(document).keydown(function(e) {
                    if (e.keyCode === 27) {
                        self.$overlayNew.removeClass('open');
                    }
                });

                if (Util.isMobile() || Util.isIpad()) {
					/*
					 initialize mobile menu,
					 do not initialize mobile menu when there is an inline playlist underneath video
					 wait for player to load, event triggered in /brandplay2/modules/video/brand_player.js
					 */
                    if(self.playerReady) MobileMenu.init(self);
                }
                //END: Link Bindings //
            }

            // do not show sponsorline when inside an iframe
            if(window.parent != window.self) {
                $('body').addClass('inside_iframe');
            } else {
                self.$sponsorLine.fadeIn().css('display', 'flex');
            }

            // Early ie Flag for scrub tracking
            if (Util.isIE() && Util.ieVer() <=9) {
                $('.vjs-progress-control, .vjs-progress-holder, .vjs-slider, .vjs-load-progress, .vjs-play-progress, .vjs-seek-handle').on('mousedown', function() {
                    if (!self._var().videoplayerObject._var().instances[self._var().videoplayerObject._var().instanceCurrPlaying].paused()) {
                        self._var().ieScrubFlag = true;
                    }
                });
            }

            function isTrackingReady() {
                if($('#menuDropdown').length === 0) {
                    window.requestAnimationFrame(isTrackingReady);
                } else {
                    self.bpTracking();
                    if (!(Util.isIE() && Util.ieVer() < 9) && self._var().enableHeartbeat) {
                        self._var().trackingBp.heartbeatTrack(self._var().videoplayerObject);
                    }
                    // Setup ISI and bindings
                    self.setupIsi();
                }
            }
            window.requestAnimationFrame(isTrackingReady);
        });

        return self;
    };

	/* Refresh function */
    thisObject.prototype.refresh = function(initFlag) {
        var self = this;
        self.notify('Trace', 'refresh');
    };

	/* Kill function */
    thisObject.prototype.kill = function() {
        this.notify('Trace', 'kill');
        _notify.rem(this._id());
    };

    // UNIQUE MODULE METHODS---------------------------------------------------------------------------------------------------------------------------------------------

	/* Setup the chapter list in a menu  */
    thisObject.prototype.setupChapterListMenu = function() {

        var self = this;

        // Only set this up if it has been specified by the producer
        if (self._var().mobile.chapterList.showAsMenu) {

            var chapterListMenuButton = $('#chapterListMenuButton');

            // Chapter List Menu button binding
            chapterListMenuButton.click( function() {
                // Show the overlay
                if (self.$overlayNew.hasClass('open')) {
                    self.$overlayNew.removeClass('open');
                } else {
                    self.$overlayNew.addClass('open');
                }
            });
        }
    };

	/* Setup ISI on load and binding */
    thisObject.prototype.setupIsi = function() {
        const self = this,
            overlay = $('#solidOverlay'),
            content =  $('.' + self._var().isi.container).html(),
            magnifyElement = $('.magnify'),
            $body = $('body'),
            $bpContent = $('#bp_content'),
            $bpDisclaimer = $('.bp_disclaimer'),
            $video = $('video');

        function hideOverlay() {
            overlay.hide();
            $('video, div').removeClass('tempHideVideo');
        }
        function replaceURLslashes(url) {
            return url.replace(/\/$/, '');
        }
        // Actually shows the overlay, and binds the demagnify button
        function showOverlay(fromIsi) {
            // Show Overlay
            overlay.show();
            // only bind and track links once!
            if(!thisObject.prototype.isiStatus.setup) {
                thisObject.prototype.isiStatus.setup = true;
                // Put content in overly
                overlay.html(content);
                // add the tracking events
                // the click handler is already managed by thisObject.prototype.addTrackHandlers
                overlay.find('a').each(function(i, e) {
                    if(thisObject.prototype.checkHref(this.href)) {
                        if (this.href.match(/\.medscape/g) !== null) {
                            var inthref = self.removeEnvName(replaceURLslashes(this.href));
                            self._var().trackingBp.pamHash('INTLINK_' + inthref, 'vidvbp-intlink', this);
                        } else {
                            self._var().trackingBp.pamHash('EXTLINK_' + replaceURLslashes(this.href), 'vidvbp-extlink', this);
                        }
                    }
                });
            }
        }

        // Clicking magnify will take all html underneath its parent and put it in a solid overlay
        $body.on('click', '.magnify', function() {
            if($body.hasClass('isi-open')) {
                if(Util.isMobile() === false) {
                    if(typeof window.hideOverlayTimeout !== 'undefined') {
                        window.clearTimeout(window.hideOverlayTimeout);
                        delete window.hideOverlayTimeout;
                    }
                }
                hideOverlay();
                $bpContent.show();
                $bpDisclaimer.show();
                self.notify('TrackBind', ['pamTrack', 'ISI_CLOSE', 'vidvbp-action_isi_close', this]);
            } else {
                showOverlay();
                self.notify('TrackBind', ['pamTrack', 'ISI_OPEN', 'vidvbp-action_isi_open', this]);
            }
            $body.toggleClass('isi-open');
        });

        // If show on load is true, show the overlay on initial load.  Else hide overlay as it is by default on
        if (self._var().isi.showOnload) {
            if(
                (Util.isMobile() === false && self._var().isi.showOnDesktop === true) ||
                (Util.isMobile() === true  && self._var().isi.showOnMobile  === true)
            ) {
                showOverlay(true);
                if(typeof self._var().isi.timeOut !== 'undefined') {
                    var timeoutValue = (isNaN(parseInt(self._var().isi.timeOut)))? 0 : parseInt(self._var().isi.timeOut);
                    if(timeoutValue > 0) {
                        window.hideOverlayTimeout = window.setTimeout(hideOverlay, timeoutValue);
                    }
                }
            } else {
                hideOverlay();
            }
        } else {
            hideOverlay();
        }
        // It's hidden on load to prevent it jumping around
        magnifyElement.show();
    };

	/* Main method to setup the Question and Answer module, on init*/
    thisObject.prototype._setupQna = function() {
        var self = this;

        if (self._var().qna.killswitch === false && $('.question').length !== 0) {
            //Instantiate object & grab XML
            var qnaModule = new Qna();

            //Merge settings
            $.extend(true, qnaModule._var(), self._var().qna);

            //Initialize
            qnaModule.init();
        }
    };

    thisObject.prototype.bpTracking = function() {
        var self = this;

        ////// TRACKING //////
        self._var().trackingBp = new tracking({
            ippEnable : true,
            appRequestCSD: true,
            pamProductName : 'brandplay'
        });

        self._var().trackingBp.init();

        for (x = 1; x <= self._var().totalVids; x++) {
            self._var().trackingBp.pamHash('ARTICLE-' + x, x, this);
        }

        //// PAM Tracking for Specific Time on all vids at init
        for (x = 1; x <= self._var().totalVids; x++) {
            for (let y = 0; y < self._var().specificPercentArray.length; y++) {
                self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_' + self._var().specificPercentArray[y] + 'pct', this);
            }
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_100pct', this);
        }

        //// PAM Tracking for stayalive ping at init
		/* for (x=1; x <= self._var().totalVids; x++) {
		 self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_stayalive', this);
		 };	*/

        //// PAM Tracking for video begins playing at init
        for (x = 1; x <= self._var().totalVids; x++) {
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp_start', this);
        }

        //// PAM Tracking for Player Controls
        for (x = 1; x <= self._var().totalVids; x++) {
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_play');
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_pause');
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_scrb');
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_vol');
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_bigr');
            self._var().trackingBp.pamHash('ARTICLE-' + x, 'vidvbp-ctl_smalr');
        }
        self._var().trackingBp.pamHash('INFO', 'vidvbp-action-info_open', document.getElementById("notes"));
        self._var().trackingBp.pamHash('INFO', 'vidvbp-action-info_close', $(".overlay-close")[0]);
        self._var().trackingBp.pamHash('ACTIONSHEET_OPEN', 'vidvbp-action_sheet_open', document.getElementById("menu"));
        self._var().trackingBp.pamHash('ACTIONSHEET_CLOSE', 'vidvbp-action_sheet_close', $('#pageWrapper'));
        self._var().trackingBp.pamHash('ISI_OPEN', 'vidvbp-action_isi_open', $('.magnify')[0]);
        self._var().trackingBp.pamHash('ISI_CLOSE', 'vidvbp-action_isi_close', $('.magnify')[0]);

        ////// Tracking the list items of Menu click ///////
        self.$menuDropDown.find('li').each(function() {
            $(this).on('click', function() {
                self.notify('TrackBind', ['pamTrack', 'OPTION' + ($(this).index()), 'vidvbp-action_' + ($(this).index()), this]);
            });
            self._var().trackingBp.pamHash('OPTION' + ($(this).index()), 'vidvbp-action_' + ($(this).index()), this);
        });
        ////// add event handler to all tracking links
        thisObject.prototype.addTrackHandlers.bind(self, self._var()['trackingBp'])();

        self.notify('TrackBind', ['pamHash', 'CLOSE', 'vidvbp-close', this]);


        ////Allow for data services to pull the PAM table
        if (window.location.href.match('getHash') !== null) {
            self._var().trackingBp.getHashTable();
        }
    };

    thisObject.prototype.addTrackHandlers = function(trackingBP) {
        const self = this;
        const trackCallBack = (e) => {
            let ele = e.currentTarget;
            if (thisObject.prototype.checkHref(ele.href)) {
                // pause video player on isi link click
                $(window).trigger('player:pause');
                if (ele.href.match(/\.medscape/g) !== null) {
                    let inthref = self.removeEnvName(ele.href.replace(/\/$/, ''));
                    self.notify('TrackBind', ['pamTrack', 'INTLINK_' + inthref, 'vidvbp-intlink', ele]);
                } else {
                    self.notify('TrackBind', ['pamTrack', 'EXTLINK_' + ele.href.replace(/\/$/, ''), 'vidvbp-extlink', ele]);
                }
            }
        };
        const checkIntExtLink = (i, ele) => {
            $(ele).attr('data-bpTrack', true).addClass('bp-track');
            if (thisObject.prototype.checkHref(ele.href)) {
                if (ele.href.match(/\.medscape/g) !== null) {
                    let inthref = self.removeEnvName(ele.href.replace(/\/$/, ''));
                    trackingBP.pamHash('INTLINK_' + inthref, 'vidvbp-intlink', ele);
                } else {
                    trackingBP.pamHash('EXTLINK_' + ele.href.replace(/\/$/, ''), 'vidvbp-extlink', ele);
                }
            }
        };
        self.$pageWrapper
            .add('a').filter(function() {
            return $(this).parents('#menuDropdown').length === 0;
        })
            .each(checkIntExtLink)
            .on('click', 'a[data-bpTrack="true"]', trackCallBack);

        ///// patch for the script hack in the jsp, only add handlers if they have not been previously attached
        if(Util.isMobile() && $('.HackedHeaderWrap a').length === 0) {
            var $bpContent =  $('#bp_content');
            $bpContent
                .add('a').filter(function() {
                return $(this).parents('#menuDropdown').length === 0;
            })
                .each(checkIntExtLink)
                .off('click')
                .on('click', '.HackedHeaderWrap a', trackCallBack);
        }
    };

    thisObject.prototype.checkHref = function(href) {
        return (typeof href !== 'undefined' && href !== '' && href !== window.location.href.split('#')[0] + '#' && href !== '#');
    };

    ////// Removes the environment name from the link ///////
    thisObject.prototype.removeEnvName = function(href) {
        var regEx = new RegExp(/\.staging|\.proddev|\.qa00|\.qa01|\.qa02/i);
        return href.replace(regEx, '');
    };

    thisObject.prototype.getBookmark = function(data) {
        try {
            var self = this;
            if (typeof data.lastscene !== 'undefined') {
                if (Number(data.lastscene) >= Number(self._var().totalVids)) {
                    self._var().bookmarkedVid = 1;
                }
                else {
                    self._var().bookmarkedVid = (Number(data.lastscene) + 1);
                }
                self.notify('PageNamePAM', 'ARTICLE-' + self._var().bookmarkedVid);
                self.notify('TrackBind', ['omniPageview', self._var().bookmarkedVid, this]);
                self.notify('BookmarkedVideo', data);
            }
            else {
                self._var().bookmarkedVid = 1;
                self.notify('PageNamePAM', 'ARTICLE-' + self._var().bookmarkedVid);
                self.notify('TrackBind', ['omniPageview', self._var().bookmarkedVid, this]);
                self.notify('BookmarkedVideo', data);
            }
        } catch (err) {
            console.log(err);
        }
    };
    return (thisObject);
});



// WEBPACK FOOTER //
// ./assets/js/brandplay.js